<template>
  <div class="error">
    <img :src="require('@/assets/common/error/error401.png')" alt="">
    <div class="content">
      <div class="text">抱歉，您的访问权限已过期，请重新登录</div>
      <van-button type="info" round size="small" @click="submit">重新登录</van-button>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Error401',
    data () {
      return {}
    },
    created () {
      this.xy.unloading()
    },
    methods: {
      submit () {
        this.xy.removeCookie('.XYTOKEN')
        this.$router.replace({ path: '/login' })
      }
    }
  }
</script>
<style lang="less" scoped>
  .error{
    background: #fff;
    text-align: center;
    padding-top: 200px;
    height: 100%;
    img{
      width:90%;
      margin-bottom:100px;
    }
    .content{
      .text{
        margin-top:20px;
        margin-bottom:40px;
        font-size: 30px;
        color:rgba(0,0,0,0.45);
      }
    }
  }
</style>
